function Card(props: {
  variant?: string;
  extra?: string;
  children?: JSX.Element | any[];
  [x: string]: any;
}) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`relative flex flex-col rounded-[10px] border-[1px] border-borderPrimary bg-surfacePrimary bg-clip-border shadow-md text-textPrimary transition-colors duration-200 ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
